import React from 'react';
import RowMenu from '../util/RowMenu';
import Modal from '../util/Modal';
import PostLink from '../util/PostLink';
import Link from '../util/Link';
import EditUserModal from '../admin_area/users/EditUserModal';
import PropTypes from 'prop-types';

import { IntlProvider } from 'react-intl';
import { translations } from '../util/i18n';

const UsersRowMenu = (props) => {
  const options = [];

  if (props.updateUserUrl) {
    options.push({
      title: 'users.dropdown.edit-user',
      component: Modal,
      params: {
        title: 'users.dropdown.edit-user',
        content: EditUserModal({ url: props.updateUserUrl, userDetails: { ...props.userDetails } }),
      },
    });
  }

  if (props.editUserUrl) {
    options.push({
      title: 'users.dropdown.edit-user',
      component: Link,
      params: {
        url: props.editUserUrl,
      },
    });
  }

  if (props.viewStudentUrl) {
    options.push({
      title: 'users.dropdown.view-student',
      component: Link,
      params: {
        url: props.viewStudentUrl,
      },
    });
  }

  options.push({
    title: 'users.dropdown.send-password-action',
    component: PostLink,
    params: {
      url: props.sendPasswordUrl,
      notice: 'users.dropdown.send-password-complete',
      refresh: false,
    },
  });

  if (props.grantAdminUrl) {
    options.push({
      title: 'users.dropdown.grant-admin',
      component: PostLink,
      params: {
        url: props.grantAdminUrl,
        refresh: true,
        confirmMessage: 'users.dropdown.grant-admin-confirm',
      },
    });
  }

  if (props.revokeAdminUrl) {
    options.push({
      title: 'users.dropdown.revoke-admin',
      component: PostLink,
      params: {
        url: props.revokeAdminUrl,
        refresh: true,
        confirmMessage: 'users.dropdown.revoke-admin-confirm',
      },
    });
  }

  if (props.grantOrgAdminUrl) {
    options.push({
      title: 'users.dropdown.grant-org-admin',
      component: PostLink,
      params: {
        url: props.grantOrgAdminUrl,
        refresh: true,
        confirmMessage: 'users.dropdown.grant-org-admin-confirm',
      },
    });
  }

  if (props.revokeOrgAdminUrl) {
    options.push({
      title: 'users.dropdown.revoke-org-admin',
      component: PostLink,
      params: {
        url: props.revokeOrgAdminUrl,
        refresh: true,
        confirmMessage: 'users.dropdown.revoke-org-admin-confirm',
      },
    });
  }

  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      <RowMenu options={options}></RowMenu>
    </IntlProvider>
  );
};

UsersRowMenu.propTypes = {
  updateUserUrl: PropTypes.string,
  sendPasswordUrl: PropTypes.string,
  userDetails: PropTypes.object,
  editUserUrl: PropTypes.string,
  viewStudentUrl: PropTypes.string,
  grantAdminUrl: PropTypes.string,
  revokeAdminUrl: PropTypes.string,
  grantOrgAdminUrl: PropTypes.string,
  revokeOrgAdminUrl: PropTypes.string,
};

export default UsersRowMenu;
